import config from 'config';
import { buildActionNames } from 'modules/store/util';

const moduleName = 'application';

// Action Types
export const types = buildActionNames(moduleName, [
  'APP_INIT',
  'APP_SESSION_ID_SET',
  'APP_SESSION_ID_UPDATE',
]);

// Action Creators
const appInit = () => ({
  type: types.APP_INIT,
});

const setSessionId = ({ sessionId }) => ({
  type: types.APP_SESSION_ID_SET,
  payload: {
    sessionId,
  },
});

const updateSessionId = () => ({
  type: types.APP_SESSION_ID_UPDATE,
});

export const actions = {
  appInit,
  setSessionId,
  updateSessionId,
};

// Initial state
export const initialState = {
  loaded: {
    session: false,
  },
  sessionId: '',
  ...config,
};

// Reducers
const applicationReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.APP_SESSION_ID_SET:
      return {
        ...state,
        loaded: {
          ...state.loaded,
          session: true,
        },
        ...action.payload,
      };
    case types.APP_CB_VALIDATION_SET:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default applicationReducer;
